<template>
  <div class="news-section">
    <div class="container">
      <h1>{{ settings.newsTitle || '最新消息 ' }}</h1>
      <div class="pure-g">
        <div class="pure-u-1 pure-u-md-1-2">
          <div class="column column--left">
            <OwlCarousel class="slider" :options="sliderOptions">
              <div v-for="video in videos" :key="video.url" class="item">
                <a
                  :href="`${video.url}&showinfo=0&rel=0&mute=1&autoplay=1`"
                  class="entry link-zoom-image"
                  data-lity
                  data-ga-label="youtube"
                  :alt="video.title">
                  <div class="cover cover--video">
                    <img :data-src="video.image_url" class="lazyload" />
                  </div>
                </a>
                <div class="title" v-text="video.title"></div>
              </div>
            </OwlCarousel>
          </div>
        </div>
        <div class="pure-u-1 pure-u-md-1-2">
          <div class="column column--right">
            <div v-for="entry in latestNewsList" :key="entry.id" class="item">
              <a :href="entry.url" class="entry entry--news link-zoom-image" data-ga-label="最新消息" :alt="entry.name">
                <div class="cover">
                  <img :src="entry.coverImages[300] || 'themes/frontend/assets/images/noimage.jpg'" alt="" />
                </div>
              </a>
              <div class="text">
                <div class="date">{{ entry.date }}</div>
                <div class="title">{{ entry.name }}</div>
              </div>
            </div>
            <a class="button button--more" href="news">更多消息</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OwlCarousel from '@/modules/ui/owlCarousel.vue'
import '../../../assets/scripts/index.js'

export default {
  components: {
    OwlCarousel,
  },
  props: {
    news: Array,
    videos: Array,
    settings: Object,
  },
  data: function () {
    return {
      current: {
        category: '最新消息',
      },
    }
  },
  computed: {
    categorizedNews() {
      return this.news
    },
    latestNewsList() {
      return this.news.slice(0, 2)
    },
    sliderOptions() {
      return { nav: true, navText: [`<i class="angle left icon"></i>`, `<i class="angle right icon"></i>`], responsive: { 0: { items: 1 } } }
    },
  },
}
</script>

<style lang="stylus" scoped>
$colorActive = #27A7E1
$borderRadius = 10px

.news-section
  padding-top 0px
  @media (max-width 767px)
    padding-top 0rem
    margin-bottom 2em
  h1
    text-align center
  .column
    margin-right 1rem
    &--right
      > *
        display flex
        .entry
          width 50%
          flex-shrink 0
        .text
          width 50%
          flex-shrink 0
          margin-left 1rem
          display flex
          flex-direction column
          justify-content center
          .date
            color #666
          .title
            display -webkit-box
            -webkit-line-clamp 3
            -webkit-box-orient vertical
            overflow hidden
            text-overflow ellipsis
            height 1.5 * 3rem
            font-size 1.1rem
  .item
    margin-bottom 1rem
  .button--more
    width 50%
    min-height 28px
    font-size 1rem
    padding: 1.5% 1rem

@media (max-width 767px)
  .news-section
    .button--more
      margin auto
      min-width 60%

.slider /deep/
  margin-bottom 3rem
  margin-right 1rem
  .title
    display -webkit-box
    -webkit-line-clamp 1
    -webkit-box-orient vertical
    overflow hidden
    text-overflow ellipsis
    text-align center
    margin-top .5rem
    margin-left 3rem
    margin-right 3rem
    margin-bottom 1.5rem
  .owl-dots
    position absolute
    left 3rem
    right 3rem
    bottom 0
    .owl-dot span
      height 7px
      width 7px
      margin-bottom 0
  .owl-nav
    display flex
    justify-content space-between
    position absolute
    left 0
    right 0
    bottom .5rem
    > *
      border-radius 50%
      height 2rem
      width 2rem
      border-radius 50%
      height 2rem
      width 2rem
      display flex
      align-items center
      justify-content center
      line-height 1
      i
        margin 0

.entry
  height auto
  background white
  display block
  position relative
  &:after
    content ' '
    display block
    padding 1px
  .cover
    position relative
    height 0
    width 100%
    border-radius $borderRadius
    overflow hidden
    padding-top (80 / 165) * 100%
    &--video
      padding-top (208 / 335) * 100%
      &:before
        content ''
        background url('~@/assets/site/video-button-play.png')
        position absolute
        left 0
        top 0
        width 100%
        height 100%
        z-index 10
        background-repeat no-repeat
        background-position center
        // background-size 25%
        pointer-events none
    img
      object-fit cover
      position absolute
      width 100%
      height 100%
      top 0
      left 0
      // transform scale(1.05)
</style>
